<template>
  <el-dialog title="分配督导" :visible.sync="visible" width="520px" :close-on-click-modal="false">
    <el-form ref="form" :model="form" label-width="100px" size="small">
      <el-form-item label="老师：">
        <span>{{ row.realName }}（{{ row.levelName }} {{ row.mobile }}）</span>
      </el-form-item>
      <el-form-item label="当前督导：">
        <span>{{ row.supervisorRealName || '未分配' }}</span>
      </el-form-item>
      <el-form-item label="所属督导：" prop="supervisorId">
        <el-select v-model="form.supervisorId" placeholder="请选择督导（留空=清除归属）" clearable
                   filterable
                   style="width:100%">
          <el-option v-for="s in options" :key="s.id" :label="`${s.realName} (${s.mobile})`" :value="s.id" />
        </el-select>
        <div class="tip">只影响【教培数据统计】里督导能看到哪些老师，不改变上级/团队关系</div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" :loading="loading" @click="submit">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import technicianInfoApi from '@/api/technical/technicianInfo'

/**
 * 分配督导（REQ-2026-125349）
 * 督导 = technical_service_level.id 2；归属写 technician_info.supervisor_id
 */
export default {
  data() {
    return {
      visible: false,
      loading: false,
      row: {},
      options: [],
      form: { supervisorId: null }
    }
  },
  methods: {
    open(row) {
      this.row = row
      this.form.supervisorId = row.supervisorId || null
      this.visible = true
      if (!this.options.length) {
        technicianInfoApi.listPageForMini({ levelId: 2, status: 10, pageNo: 1, pageSize: 100 }).then(({ data }) => {
          this.options = (data && data.list) || []
        })
      }
    },
    submit() {
      this.loading = true
      technicianInfoApi.updateSupervisor({ id: this.row.id, supervisorId: this.form.supervisorId || null }).then(() => {
        this.$message.success('操作成功')
        this.visible = false
        this.$emit('created')
      }).finally(() => { this.loading = false })
    }
  }
}
</script>

<style scoped>
.tip {
  color: #909399;
  font-size: 12px;
  line-height: 18px;
  margin-top: 4px;
}
</style>
